import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "@services/baseQuery"; // adjust path as needed
import { getUrlParamsFromArray } from "@helperFunctions/api/getUrlParamsFromArray";
import { getSortingUrlParams } from "@helperFunctions/api/getSortingUrlParams";
import { FormApiResponse } from "../types/apiResponse/FormApiResponse.interface";
import { IContentType } from "../types/settings/formBuilder/IContentType.interface";
import { EOrderBy } from "src/enums/EOrderBy";
import { IFormPackage } from "../types/formAssignments/packages/IFormPackage";
import { EActiveStatus } from "../types/formsTable/EActiveStatus.enum";

const BASE_URL = import.meta.env.VITE_APP_YAPI_DATAFORMS;

export const dataFormsApi = createApi({
  reducerPath: "dataFormsApi",
  baseQuery: baseQueryWithReauth(BASE_URL, "json" as IContentType),
  endpoints: (builder) => ({
    getForms: builder.query<FormApiResponse, undefined>({
      query: () => {
        const orderBy: string = getSortingUrlParams([
          { field: "name", sort: EOrderBy.asc },
        ]);

        let url = `/odata/Forms?$count=true&$orderby=${orderBy}&$take=null&$skip=0`;

        url += getUrlParamsFromArray("category", []);
        url += getUrlParamsFromArray("language", []);
        url += getUrlParamsFromArray("activeStatus", [EActiveStatus.Active]);

        return { url, method: "GET" };
      },
      keepUnusedDataFor: 0,
    }),
    getPackages: builder.query<IFormPackage[], string | undefined>({
      query: (name) => `packages${name ? `?name=${name}` : ""}`,
    }),
  }),
});

export const { useGetFormsQuery, useGetPackagesQuery } = dataFormsApi;
